import { Component, type ReactNode } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth.ts'
import { Layout } from '@/components/layout/Layout.tsx'
import { LoginPage } from '@/pages/auth/LoginPage.tsx'
import { AuthCallbackPage } from '@/pages/auth/AuthCallbackPage.tsx'
import { DashboardPage } from '@/pages/dashboard/DashboardPage.tsx'
import { MyDayPage } from '@/pages/my-day/MyDayPage.tsx'
import { TicketsPage } from '@/pages/tickets/TicketsPage.tsx'
import { TicketDetailPage } from '@/pages/tickets/TicketDetailPage.tsx'
import { QuotationViewPage } from '@/pages/tickets/QuotationViewPage.tsx'
import { ZeiterfassungPage } from '@/pages/zeiterfassung/ZeiterfassungPage.tsx'
import { KalenderPage } from '@/pages/kalender/KalenderPage.tsx'
import { TelefoniePage } from '@/pages/telefonie/TelefoniePage.tsx'
import { DocumentsPage } from '@/pages/documents/DocumentsPage.tsx'
import { PasswordSendPage } from '@/pages/passwords/PasswordSendPage.tsx'
import { PasswordGeneratorPage } from '@/pages/passwords/PasswordGeneratorPage.tsx'
import { PasswordRetrievePage } from '@/pages/passwords/PasswordRetrievePage.tsx'
import { NetworkOverviewPage } from '@/pages/network/NetworkOverviewPage.tsx'
import { NetworkVisualizationPage } from '@/pages/network/NetworkVisualizationPage.tsx'
import { UnifiPage } from '@/pages/network/UnifiPage.tsx'
import { MonitoringPage } from '@/pages/monitoring/MonitoringPage.tsx'
import { StatistikenPage } from '@/pages/statistiken/StatistikenPage.tsx'
import { StatsDashboardPage } from '@/pages/statistiken/StatsDashboardPage.tsx'
import { WccDashboardPage } from '@/pages/statistiken/WccDashboardPage.tsx'
import { AuswertungenKundenPage } from '@/pages/auswertungen/AuswertungenKundenPage.tsx'
import { MarketplacePage } from '@/pages/marketplace/MarketplacePage.tsx'
import { ShippingPage } from '@/pages/shipping/ShippingPage.tsx'
import { PaketscheinPage } from '@/pages/shipping/PaketscheinPage.tsx'
import { BriefpostPage } from '@/pages/shipping/BriefpostPage.tsx'
import { PensakiPage } from '@/pages/shipping/PensakiPage.tsx'
import { VertraegePage } from '@/pages/vertraege/VertraegePage.tsx'
import { VertraegeDashboardPage } from '@/pages/vertraege/VertraegeDashboardPage.tsx'
import { VertraegeKundensichtPage } from '@/pages/vertraege/VertraegeKundensichtPage.tsx'
import { ContractDetailPage } from '@/pages/vertraege/ContractDetailPage.tsx'
import { ProductDetailPage } from '@/pages/vertraege/ProductDetailPage.tsx'
import { VertragsvorlagenPage } from '@/pages/stammdaten/VertragsvorlagenPage.tsx'
import { VertragsvorlagenEditorPage } from '@/pages/stammdaten/VertragsvorlagenEditorPage.tsx'
import { AutomaticSupportWorkflowPage } from '@/pages/abrechnung/AutomaticSupportWorkflowPage.tsx'
import { VertriebsboardPage } from '@/pages/vertrieb/VertriebsboardPage.tsx'
import { ArtikelPage } from '@/pages/artikel/ArtikelPage.tsx'
import { ArtikelSettingsPage } from '@/pages/artikel/settings/ArtikelSettingsPage.tsx'
import { AirkeySettingsPage } from '@/pages/airkey/AirkeySettingsPage.tsx'
import { SchluesselverwaltungPage } from '@/pages/airkey/SchluesselverwaltungPage.tsx'
import { LieferantenPage } from '@/pages/einkauf/LieferantenPage.tsx'
import { MasterDataSyncPage } from '@/pages/einkauf/MasterDataSyncPage.tsx'
import { HerstellerMappingPage } from '@/pages/einkauf/HerstellerMappingPage.tsx'
import { BedarfserfassungPage } from '@/pages/einkauf/BedarfserfassungPage.tsx'
import { AnfragenPage } from '@/pages/einkauf/AnfragenPage.tsx'
import { SupplierPortalPage } from '@/pages/einkauf/SupplierPortalPage.tsx'
import { TerminplanerPage } from '@/pages/terminplaner/TerminplanerPage.tsx'
import { TerminbuchungPage } from '@/pages/terminbuchung/TerminbuchungPage.tsx'
import { DokumentationPage } from '@/pages/dokumentation/DokumentationPage.tsx'
import { UrlaubPage } from '@/pages/urlaub/UrlaubPage.tsx'
import { SettingsPage } from '@/pages/settings/SettingsPage.tsx'
import { CalendarDiagnosticsPage } from '@/pages/settings/CalendarDiagnosticsPage.tsx'
import { CwaOverviewPage } from '@/pages/cwa/CwaOverviewPage.tsx'
import { FeaturesPage } from '@/pages/features/FeaturesPage.tsx'
import { EsetOverviewPage } from '@/pages/eset/EsetOverviewPage.tsx'
import { AlsoMarketplacePage } from '@/pages/also/AlsoMarketplacePage.tsx'
import { InvoicesPage } from '@/pages/invoices/InvoicesPage.tsx'
import { InvoiceDetailPage } from '@/pages/invoices/InvoiceDetailPage.tsx'
import { NeukundengewinnungPage } from '@/pages/neukundengewinnung/NeukundengewinnungPage.tsx'
import ContentBriefPage from '@/pages/marketing/ContentBriefPage.tsx'
import SeoPage from '@/pages/marketing/SeoPage.tsx'
import { LinkedInProfilesPage } from '@/pages/neukundengewinnung/LinkedInProfilesPage.tsx'
import { BuchhaltungPage } from '@/pages/buchhaltung/BuchhaltungPage.tsx'
import { BwaPage } from '@/pages/buchhaltung/BwaPage.tsx'
import { WiederkehrendePage } from '@/pages/buchhaltung/WiederkehrendePage.tsx'
import { OposPage } from '@/pages/buchhaltung/OposPage.tsx'
import { PlanListPage } from '@/pages/liquiditaet/planung/PlanListPage.tsx'
import { PlanEditorPage } from '@/pages/liquiditaet/planung/PlanEditorPage.tsx'
import { NinjaDevicesPage } from '@/pages/infrastruktur/NinjaDevicesPage.tsx'
import { CmdbPage } from '@/pages/cmdb/CmdbPage.tsx'
import { PaperclipPage } from '@/pages/paperclip/PaperclipPage.tsx'
import { PaperclipMonitorPage } from '@/pages/paperclip/PaperclipMonitorPage.tsx'
import { ItStructuresOverviewPage } from '@/pages/it-structures/ItStructuresOverviewPage.tsx'
import { GlobalStandardsPage } from '@/pages/it-structures/GlobalStandardsPage.tsx'
import { CustomerStructurePage } from '@/pages/it-structures/CustomerStructurePage.tsx'
import { SecurityPoliciesPage } from '@/pages/security-policies/SecurityPoliciesPage.tsx'
import { ApprovalPage } from '@/pages/approvals/ApprovalPage.tsx'
import { CustomerUsersPage } from '@/pages/admin/CustomerUsersPage.tsx'
import TanssTeamsBridgePage from '@/pages/admin/TanssTeamsBridgePage.tsx'
import { UiKitPage } from '@/pages/ui-kit/UiKitPage.tsx'
import { MatrixPrototypesPage } from '@/pages/ui-kit/MatrixPrototypesPage.tsx'
import { DevToolsPage } from '@/pages/dev-tools/DevToolsPage.tsx'
import { AngebotDialogPage } from '@/pages/auftraege/AngebotDialogPage.tsx'
import { StandardsAdminPage } from '@/pages/auftraege/StandardsAdminPage.tsx'

import GpListPage from '@/pages/gp/GpListPage.tsx'
import GpDetailPage from '@/pages/gp/GpDetailPage.tsx'
import GpCampaignsPage from '@/pages/gp/GpCampaignsPage.tsx'
import GpInboxPage from '@/pages/gp/GpInboxPage.tsx'
import { EmailsPage } from '@/pages/emails/EmailsPage.tsx'
import GpDatenpflegeUebersichtPage from '@/pages/gp/GpDatenpflegeUebersichtPage.tsx'
import GpDatenpflegeWizardPage from '@/pages/gp/GpDatenpflegeWizardPage.tsx'
import OnboardingPage from '@/pages/onboarding/OnboardingPage.tsx'
import { ProcessListPage } from '@/pages/prozesse/ProcessListPage.tsx'
import { ProcessDetailPage } from '@/pages/prozesse/ProcessDetailPage.tsx'
import { ProcessStartPage } from '@/pages/prozesse/ProcessStartPage.tsx'
import { ProcessWizardPage } from '@/pages/prozesse/ProcessWizardPage.tsx'
import { TemplateListPage } from '@/pages/prozesse/TemplateListPage.tsx'
import { TemplateDesignerPage } from '@/pages/prozesse/designer/TemplateDesignerPage.tsx'
import { RoleProfilesPage } from '@/pages/prozesse/RoleProfilesPage.tsx'
import { ApprovalsPage } from '@/pages/prozesse/ApprovalsPage.tsx'
import BpFormPage from '@/pages/public/BpFormPage.tsx'
import OnboardingPortalPage from '@/pages/onboarding-portal/OnboardingPortalPage.tsx'
import { DispoAusseneinsatzPage } from '@/pages/dispo/DispoAusseneinsatzPage.tsx'
import { DispoLeistungsfreigabePage } from '@/pages/dispo/DispoLeistungsfreigabePage.tsx'
import { DispoTicketpruefungPage } from '@/pages/dispo/DispoTicketpruefungPage.tsx'
import { DispoEmailVorlagenPage } from '@/pages/dispo/DispoEmailVorlagenPage.tsx'
import { DispoKalenderPage } from '@/pages/dispo/DispoKalenderPage.tsx'
import { DispoSettingsPage } from '@/pages/dispo/DispoSettingsPage.tsx'
import { DispoFreigabeSettingsPage } from '@/pages/dispo/DispoFreigabeSettingsPage.tsx'
import { DispoServiceDefinitionsPage } from '@/pages/dispo/DispoServiceDefinitionsPage.tsx'
import { DispoKrankenstandPage } from '@/pages/dispo/DispoKrankenstandPage.tsx'
import { DispoServiceDeskPage } from '@/pages/dispo/DispoServiceDeskPage.tsx'
import { DispoAbwesenheitPage } from '@/pages/dispo/DispoAbwesenheitPage.tsx'
import { DispoChefUebersichtPage } from '@/pages/dispo/DispoChefUebersichtPage.tsx'
import { ToastProvider, TooltipProvider } from '@/components/ui'

class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state: { error: Error | null } = { error: null }
  static getDerivedStateFromError(error: Error) { return { error } }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 40, fontFamily: 'monospace' }}>
          <h2 style={{ color: '#dc2626' }}>Fehler beim Rendern</h2>
          <pre style={{ whiteSpace: 'pre-wrap', background: '#fef2f2', padding: 16, borderRadius: 8, marginTop: 12 }}>
            {this.state.error.message}
            {'\n\n'}
            {this.state.error.stack}
          </pre>
          <button onClick={() => { this.setState({ error: null }); window.location.reload() }}
            style={{ marginTop: 16, padding: '8px 16px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
            Seite neu laden
          </button>
        </div>
      )
    }
    return this.props.children
  }
}

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />
}

export default function App() {
  return (
    <ErrorBoundary>
    <TooltipProvider delayDuration={300}>
    <ToastProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        <Route path="/password/:token" element={<PasswordRetrievePage />} />
        <Route path="/public/gp-form/:token" element={<BpFormPage />} />
        <Route path="/onboarding/:token" element={<OnboardingPortalPage />} />
        <Route path="/angebot/:token" element={<SupplierPortalPage />} />

        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="my-day" element={<MyDayPage />} />
          <Route path="tickets" element={<TicketsPage />} />
          <Route path="tickets/:id" element={<TicketDetailPage />} />
          <Route path="tickets/:ticketId/angebot/:docEntry" element={<QuotationViewPage />} />
          <Route path="zeiterfassung" element={<ZeiterfassungPage />} />
          <Route path="kalender" element={<KalenderPage />} />
          <Route path="terminplaner" element={<TerminplanerPage />} />
          <Route path="terminbuchung" element={<TerminbuchungPage />} />
          <Route path="urlaub" element={<UrlaubPage />} />
          <Route path="telefonie" element={<TelefoniePage />} />
          <Route path="emails" element={<EmailsPage />} />
          <Route path="auftraege" element={<Navigate to="/dokumente" replace />} />
          <Route path="dokumente" element={<DocumentsPage />} />
          <Route path="auftraege/angebot/:quoteId" element={<AngebotDialogPage />} />
          <Route path="auftraege/standards" element={<StandardsAdminPage />} />
          <Route path="auftraege/ai-memory" element={<Navigate to="/einstellungen/ki/wissensspeicher" replace />} />
          <Route path="rechnungen" element={<InvoicesPage />} />
          <Route path="rechnungen/:id" element={<InvoiceDetailPage />} />
          <Route path="passwort/versenden" element={<PasswordSendPage />} />
          <Route path="passwort/generator" element={<PasswordGeneratorPage />} />
          <Route path="netzwerk" element={<NetworkOverviewPage />} />
          <Route path="netzwerk/visualisierung" element={<NetworkVisualizationPage />} />
          <Route path="unifi" element={<UnifiPage />} />
          <Route path="monitoring" element={<MonitoringPage />} />
          <Route path="cwa" element={<CwaOverviewPage />} />
          <Route path="dokumentation" element={<DokumentationPage />} />
          <Route path="statistiken" element={<StatistikenPage />} />
          <Route path="statistiken/dashboard" element={<StatsDashboardPage />} />
          <Route path="statistiken/wcc" element={<WccDashboardPage />} />
          <Route path="auswertungen/kunden" element={<AuswertungenKundenPage />} />
          <Route path="marketplace" element={<MarketplacePage />} />
          <Route path="artikel" element={<ArtikelPage />} />
          <Route path="einstellungen/artikel" element={<ArtikelSettingsPage />} />
          <Route path="einstellungen/airkey" element={<AirkeySettingsPage />} />
          <Route path="schluesselverwaltung" element={<SchluesselverwaltungPage />} />
          <Route path="einkauf/lieferanten" element={<LieferantenPage />} />
          <Route path="einkauf/stammdaten-abgleich" element={<MasterDataSyncPage />} />
          <Route path="einkauf/hersteller-mapping" element={<HerstellerMappingPage />} />
          <Route path="einkauf/bedarfserfassung" element={<BedarfserfassungPage />} />
          <Route path="einkauf/anfragen" element={<AnfragenPage />} />
          <Route path="versand" element={<ShippingPage />} />
          <Route path="versand/paketschein" element={<PaketscheinPage />} />
          <Route path="versand/briefpost" element={<BriefpostPage />} />
          <Route path="versand/pensaki" element={<PensakiPage />} />
          <Route path="vertrieb" element={<VertriebsboardPage />} />
          <Route path="marketing/content-briefs" element={<ContentBriefPage />} />
          <Route path="marketing/seo" element={<SeoPage />} />
          <Route path="neukundengewinnung" element={<NeukundengewinnungPage />} />
          <Route path="neukundengewinnung/linkedin" element={<LinkedInProfilesPage />} />
          <Route path="neukundenonboarding" element={<OnboardingPage />} />
          {/* Prozesse module */}
          <Route path="prozesse" element={<ProcessListPage />} />
          <Route path="prozesse/neu" element={<ProcessStartPage />} />
          <Route path="prozesse/freigaben" element={<ApprovalsPage />} />
          <Route path="prozesse/templates" element={<TemplateListPage />} />
          <Route path="prozesse/templates/:id/designer" element={<TemplateDesignerPage />} />
          <Route path="prozesse/rollen-profile" element={<RoleProfilesPage />} />
          <Route path="prozesse/:id" element={<ProcessDetailPage />} />
          <Route path="prozesse/:id/wizard" element={<ProcessWizardPage />} />
          {/* Geschaeftspartner-Modul */}
          <Route path="gp" element={<GpListPage />} />
          <Route path="gp/datenpflege" element={<GpDatenpflegeUebersichtPage />} />
          <Route path="gp/datenpflege/wizard" element={<GpDatenpflegeWizardPage />} />
          <Route path="gp/kampagnen" element={<GpCampaignsPage />} />
          <Route path="gp/posteingang" element={<GpInboxPage />} />
          <Route path="gp/:id" element={<GpDetailPage />} />
          {/* Vertraege module – top-level navigation routes */}
          <Route path="vertraege" element={<VertraegePage context="finance" />} />
          <Route path="vertraege/dashboard" element={<VertraegeDashboardPage />} />
          <Route path="vertraege/kundensicht" element={<VertraegeKundensichtPage />} />
          <Route path="vertraege/:id" element={<ContractDetailPage />} />
          <Route path="vertraege/produkte/:id" element={<ProductDetailPage />} />
          {/* Legacy-Kontext-Sichten (Vertrieb / Einkauf / Finanzen): */}
          <Route path="verkauf/vertraege" element={<VertraegePage context="sales" />} />
          <Route path="einkauf/vertraege" element={<VertraegePage context="purchase" />} />
          <Route path="finanzen/vertraege" element={<VertraegePage context="finance" />} />
          {/* Stammdaten – Vertragsvorlagen */}
          <Route path="stammdaten/vertragsvorlagen" element={<VertragsvorlagenPage />} />
          <Route path="stammdaten/vertragsvorlagen/editor" element={<VertragsvorlagenEditorPage />} />
          <Route path="finanzen/support-workflow" element={<AutomaticSupportWorkflowPage />} />
          <Route path="dispo" element={<Navigate to="/dispo/service-desk" replace />} />
          <Route path="dispo/ausseneinsatz" element={<DispoAusseneinsatzPage />} />
          <Route path="dispo/leistungsfreigabe" element={<DispoLeistungsfreigabePage />} />
          <Route path="dispo/ticketpruefung" element={<DispoTicketpruefungPage />} />
          <Route path="dispo/email-vorlagen" element={<DispoEmailVorlagenPage />} />
          <Route path="dispo/kalender" element={<DispoKalenderPage />} />
          <Route path="dispo/krankenstand" element={<DispoKrankenstandPage />} />
          <Route path="dispo/service-desk" element={<DispoServiceDeskPage />} />
          <Route path="dispo/abwesenheit" element={<DispoAbwesenheitPage />} />
          <Route path="dispo/chef-uebersicht" element={<DispoChefUebersichtPage />} />
          <Route path="einstellungen/dispo" element={<DispoSettingsPage />} />
          <Route path="einstellungen/dispo/leistungsfreigabe" element={<DispoFreigabeSettingsPage />} />
          <Route path="einstellungen/dispo/dienste" element={<DispoServiceDefinitionsPage />} />
          <Route path="einstellungen/*" element={<SettingsPage />} />
          <Route path="einstellungen/kalender-diagnose" element={<Navigate to="/debug/kalender-diagnose" replace />} />
          <Route path="eset" element={<EsetOverviewPage />} />
          <Route path="also-marketplace" element={<AlsoMarketplacePage />} />
          <Route path="features" element={<FeaturesPage />} />
          <Route path="buchhaltung" element={<Navigate to="/finanzen/kontoauszuege" replace />} />
          <Route path="finanzen" element={<Navigate to="/finanzen/kontoauszuege" replace />} />
          <Route path="finanzen/banken" element={<Navigate to="/finanzen/kontoauszuege" replace />} />
          <Route path="finanzen/sap-buchungen" element={<Navigate to="/finanzen/kontoauszuege" replace />} />
          <Route path="finanzen/kontoauszuege" element={<BuchhaltungPage />} />
          <Route path="finanzen/wiederkehrend" element={<WiederkehrendePage />} />
          <Route path="finanzen/bwa" element={<BwaPage />} />
          <Route path="finanzen/opos" element={<OposPage />} />
          <Route path="finanzen/liquiditaet" element={<Navigate to="/finanzen/liquiditaet/planung" replace />} />
          <Route path="finanzen/liquiditaet/planung" element={<PlanListPage />} />
          <Route path="finanzen/liquiditaet/planung/:planId" element={<PlanEditorPage />} />
          <Route path="finanzen/integrierteplanung" element={<PlanListPage basePath="/finanzen/integrierteplanung" title="Integrierte Planung" />} />
          <Route path="finanzen/integrierteplanung/konzern" element={<PlanEditorPage basePath="/finanzen/integrierteplanung" scope="group" />} />
          <Route path="finanzen/integrierteplanung/konzern/:groupId" element={<PlanEditorPage basePath="/finanzen/integrierteplanung" scope="group" />} />
          <Route path="finanzen/integrierteplanung/:planId" element={<PlanEditorPage basePath="/finanzen/integrierteplanung" />} />
          <Route path="infrastruktur/geraete" element={<NinjaDevicesPage />} />
          <Route path="cmdb" element={<CmdbPage />} />
          <Route path="paperclip" element={<PaperclipPage />} />
          <Route path="paperclip/monitor" element={<PaperclipMonitorPage />} />
          <Route path="infrastruktur/strukturen" element={<ItStructuresOverviewPage />} />
          <Route path="infrastruktur/strukturen/global" element={<GlobalStandardsPage />} />
          <Route path="infrastruktur/strukturen/:customerId" element={<CustomerStructurePage />} />
          <Route path="infrastruktur/sicherheitsrichtlinien" element={<SecurityPoliciesPage />} />
          <Route path="freigabe/:token" element={<ApprovalPage />} />
          <Route path="admin/kunden-user" element={<CustomerUsersPage />} />
          <Route path="admin/tanss-teams-bridge" element={<TanssTeamsBridgePage />} />
          <Route path="ui-kit" element={<UiKitPage />} />
          <Route path="ui-kit/matrix-prototypes" element={<MatrixPrototypesPage />} />
          <Route path="dev-tools" element={<Navigate to="/debug" replace />} />
          <Route path="debug" element={<DevToolsPage />} />
          <Route path="debug/kalender-diagnose" element={<CalendarDiagnosticsPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
    </ToastProvider>
    </TooltipProvider>
    </ErrorBoundary>
  )
}
